if (!customElements.get('category-showcase')) {
  class CategoryShowcase extends HTMLElement {
    constructor() {
      super();
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.onChange = this.onChange.bind(this);
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-cs-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-cs-panel]'));

      this.tabs.forEach((tab) =>
        tab.addEventListener('click', () => this.activate(tab.dataset.csTab))
      );

      this.querySelectorAll('[data-cs-strip]').forEach((strip) => this.setupStrip(strip));

      // Met à jour le nom de la couleur dans la légende « Couleur : X »
      this.addEventListener('change', this.onChange);

      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    onBlockSelect(event) {
      if (!this.contains(event.target)) return;
      const id = event.target.getAttribute('data-cs-tab');
      if (id) this.activate(id);
    }

    onChange(event) {
      const input = event.target.closest('input[id^="cardProductColor-"]');
      if (!input) return;
      const fieldset = input.closest('fieldset');
      const value = fieldset && fieldset.querySelector('[data-cs-color-value]');
      if (value) value.textContent = input.value;
    }

    activate(id) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.csTab === id;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.csPanel !== id;
      });
    }

    setupStrip(strip) {
      const track = strip.querySelector('[data-cs-track]');
      const prev = strip.querySelector('[data-cs-prev]');
      const next = strip.querySelector('[data-cs-next]');
      if (!track || !prev || !next) return;

      const step = () => {
        const item = track.querySelector('li');
        if (!item) return 300;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return item.getBoundingClientRect().width + gap;
      };

      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

      const update = () => {
        const maxScroll = track.scrollWidth - track.clientWidth - 1;
        prev.toggleAttribute('disabled', track.scrollLeft <= 0);
        next.toggleAttribute('disabled', track.scrollLeft >= maxScroll);
        strip.classList.toggle('has-overflow', track.scrollWidth > track.clientWidth + 1);
      };

      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    }
  }

  customElements.define('category-showcase', CategoryShowcase);
}
